//执行设置面包屑
import eventBus from "@/events/eventBus";
import {StorageUtils} from 'xmgoing-utils';

export function executeSetCrumbName(newCrumbObj:Object){
  eventBus.emit('executeSetCrumbName', newCrumbObj);
}

//注册面包屑方法
export function onSetCrumbName(backFun){
  eventBus.off('executeSetCrumbName');
  eventBus.on('executeSetCrumbName',(newCrumbObj)=>{
    backFun&&backFun(newCrumbObj);
  });
}

export function useBreadCrumbHook(){


  const crumbObj=ref({});
  //获取当前的面包屑内容
  if(StorageUtils.getSessionItem("crumbObj")){
    try{
      crumbObj.value=JSON.parse(StorageUtils.getSessionItem("crumbObj")+"");
    }catch (e){

    }
  }

  onBeforeUnmount(()=>{
    eventBus.off('executeSetCrumbName');
  })


  onMounted(()=>{
    onSetCrumbName((newCrumbObj)=>{
      const curObj={name:newCrumbObj.name,source:newCrumbObj.source,path:newCrumbObj.path}
      StorageUtils.addSessionItem("crumbObj", JSON.stringify(curObj));
      crumbObj.value=curObj;
    })
  })
  return {
    crumbObj,
  }
}
